module.exports = __webpack_public_path__ + "570eb83859dc23dd0eec423a49e147fe.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/material-icons/MaterialIcons-Regular.woff2
// module id = 374
// module chunks = 134